var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mr-6" },
    [
      _vm.filepath
        ? [
            _c("img", {
              staticClass: "inline-block h-auto w-38 rounded-full custom-card",
              attrs: { alt: "", src: _vm.filepath },
            }),
          ]
        : [
            _c(
              "span",
              {
                staticClass:
                  "inline-flex items-center justify-center avatarHeight rounded-full bg-primary-500",
                style: _vm.bgStyle,
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "text-lg font-medium leading-none text-white uppercase",
                  },
                  [_vm._v(_vm._s(_vm.initial))]
                ),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }